export const contacts = state => state.contacts.items
export const contactsByCompanyId = state => id => _.filter(contacts(state), {company_id: id})
export const contactsByProjectId = state => id => {
    return contacts(state).filter(contact => contact.pivot.project_id === id)
}
export const contactById = state => id => _.find(contacts(state), {id})
export const contactNameById = state => id => {
    let contact = contactById(state)(id)
    return contact ? contact.full_name : null
}
